import { render, staticRenderFns } from "./AddPerson.vue?vue&type=template&id=33dda3e0"
import script from "./AddPerson.vue?vue&type=script&lang=js"
export * from "./AddPerson.vue?vue&type=script&lang=js"
import style0 from "./AddPerson.vue?vue&type=style&index=0&id=33dda3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports